import { VehicleAvatar } from "@talladega/components";
import { formatNumber } from "@talladega/helpers";
import classNames from "classnames";
import { TFunction } from "i18next";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

const getVehicleTitle = (
  year: number | null | undefined,
  make: string | null | undefined,
  model: string | null | undefined
) => {
  return [year, make, model].filter(Boolean).join(" ");
};

const getVehicleInfo = (
  trim: string | null | undefined,
  odometer: number | null | undefined,
  vin: string | null | undefined,
  locale: string,
  t: TFunction
): string => {
  return [
    trim,
    odometer
      ? `${formatNumber(odometer, locale)} ${t("km", { ns: "common" })}`
      : "",
    vin,
  ]
    .filter(Boolean)
    .join(" | ");
};

type VehicleDetails = {
  year: number;
  make: string;
  model?: string;
  trim?: string;
  vin?: string;
  odometer?: number;
};

type Props = {
  vehicleDetails: VehicleDetails;
  className?: string;
  ctaElements?: React.ReactNode;
};

const WarrantyVehicleInfoCard = ({
  vehicleDetails,
  className,
  ctaElements,
}: Props) => {
  const { t } = useTranslation(["purchase", "common"]);
  const locale = useRouter().locale || "en";

  const { year, make, model, trim, vin, odometer } = vehicleDetails || {};

  return (
    <div
      id="vehcile-details-container"
      className={classNames(
        "flex flex-col w-full items-start rounded-lg",
        className
      )}
    >
      <div className="flex flex-col p-4 w-full">
        <div className="flex gap-3 md:gap-3">
          {year && make && (
            <>
              <div className="hidden lg:flex flex-shrink-0">
                <VehicleAvatar size="sm" year={year} make={make} />
              </div>
              <div className="flex lg:hidden flex-shrink-0">
                <VehicleAvatar size="xs" year={year} make={make} />
              </div>
            </>
          )}
          <div className="w-full flex flex-col items-start">
            <div className="text-sm md:text-md lg:text-lg font-bold">
              {getVehicleTitle(year, make, model)}
            </div>
            <div className="hidden md:block text-sm">
              {getVehicleInfo(trim, odometer, vin, locale, t)}
            </div>
            <div className="md:hidden text-xs flex-col text-start">
              {getVehicleInfo(trim, odometer, vin, locale, t)}
            </div>
            <div className="mt-2">{ctaElements}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarrantyVehicleInfoCard;
